<template>
	<div id="application-container">
		<v-loader v-if="showLoader" />
		<v-header />
		<div class="row">
			<div class="col-md-12">
				<v-menu @menuAcessado="tratarMensagemInicial" />
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<main class="container-fluid">
					<router-view />
				</main>
			</div>
		</div>
		<div v-show="exibirMensagemInicial">
			<div class="row">
				<div class="col-md-1">
					<img src="../../../../assets/img/logo_cipa_sesmt.png" class="pull-left" alt="logo" style="height:150px;width:auto">
				</div>
				<div class="col-md-10">
					<h3><b>ELEIÇÕES DA CIPA!</b></h3>
					<br>
					<br>
					<h4><b>Bem-vindo Servidor!</b></h4>
					<br>
					<br>
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-1 col-md-8">
					<div style="border: solid 1px black">
						<p>Para participar da Eleição siga estes passos:</p>
						<p>1. <b>Cadastrar:</b> Informe seus dados para habilitar a sua participação, o seu e-mail será validado para garantir a segurança do processo.</p>
						<br>
						<p>2. <b>Após o cadastro,</b> Clique em Votação, escolha seu candidato e confirme seu voto.</p>
						<br>
						<p>3. <b>Valide seu voto:</b> Clique no link que será enviado para seu email para finalizar a votação.</p>
						<br>
						<b>Seu voto só será computado após a confirmação por email!</b>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VLoader from '@/views/commons/loader.vue';
	import VHeader from '@/views/commons/header.vue';
	import VMenu from '@/views/commons/menu.vue';

	export default {
		components: { VLoader, VHeader, VMenu },
		data: function() {
			return {
				exibirMensagemInicial: true
			};
		},
		computed: {
			showLoader: function() {
				var ajax = this.$store.state.ajax;
				return ajax.longRequest || ajax.errors.length > 0;
			}
		},
		methods: {
			tratarMensagemInicial: function(exibir) {
				this.exibirMensagemInicial = exibir;
			}
		}
	};
</script>

<style></style>